import React from 'react';
import TableCell from './TableCell';
import InputField from './InputField';
import { formatCalculationResult, parseNumericValue } from '../utils/numberUtils';

const cleanNumericInput = (rawOrEvent, englishValue) => {
  const raw = typeof rawOrEvent === 'string' || typeof rawOrEvent === 'number'
    ? rawOrEvent
    : rawOrEvent?.target?.value;
  const next = englishValue !== undefined && englishValue !== null && englishValue !== ''
    ? englishValue
    : (raw ?? '');
  return String(next).replace(/,/g, '');
};

const SummaryRow = ({
  row,
  viewMode = false,
  handleInputChange,
  handleOperationalRowChange,
  isOperational = false,
  budgetAllocationDifference
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  const difference = budgetAllocationDifference !== undefined
    ? budgetAllocationDifference
    : parseNumericValue(row?.revisedBudget) - parseNumericValue(row?.totalBudgetDemand);

  const setField = (field) => (rawOrEvent, englishValue) => {
    if (!onChangeHandler || row?.id === undefined || row?.id === null) return;
    onChangeHandler(row.id, field, cleanNumericInput(rawOrEvent, englishValue));
  };

  // Always editable in edit mode — these are manual FY fields, never calculated
  const locked = !!viewMode;

  return (
    <>
      <TableCell className="budgetCell">
        <InputField
          value={row?.totalBudgetDemand ?? ''}
          onChange={setField('totalBudgetDemand')}
          placeholder="कुल बजेट माग"
          readOnly={locked}
          viewMode={locked}
          isNumeric={true}
        />
      </TableCell>

      <TableCell className="budgetCell">
        <InputField
          value={row?.totalBudgetExpenditure ?? ''}
          onChange={setField('totalBudgetExpenditure')}
          placeholder="कुल बजेट निकासा"
          readOnly={locked}
          viewMode={locked}
          isNumeric={true}
        />
      </TableCell>

      <TableCell className="budgetCell">
        <InputField
          value={row?.totalAuthorityReceived ?? ''}
          onChange={setField('totalAuthorityReceived')}
          placeholder="कुल अख्तियारी"
          readOnly={locked}
          viewMode={locked}
          isNumeric={true}
        />
      </TableCell>

      <TableCell className="budgetCell">
        <InputField
          value={row?.totalExpense ?? ''}
          onChange={setField('totalExpense')}
          placeholder="कुल खर्च"
          readOnly={locked}
          viewMode={locked}
          isNumeric={true}
        />
      </TableCell>

      <TableCell className="budgetCell">
        <InputField
          value={row?.totalRemainingBalance ?? ''}
          onChange={setField('totalRemainingBalance')}
          placeholder="जम्मा मौज्दात"
          readOnly={locked}
          viewMode={locked}
          isNumeric={true}
        />
      </TableCell>

      <TableCell className="budgetCell">
        {formatCalculationResult(difference, row)}
      </TableCell>
    </>
  );
};

export default SummaryRow;
